<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-3">
    <label for="r011_code">Chamado</label>
    <input id="r011_code" type="number" pInputText [(ngModel)]="filters.code"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_category">Categoria</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r011_category" [options]="comboOptions.category" [(ngModel)]="filters.category"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_status">Situação</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r011_status" [options]="comboOptions.status" [(ngModel)]="filters.status" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_enrollment">Matrícula</label>
    <input id="r011_enrollment" type="text" pInputText [(ngModel)]="filters.enrollment"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_name">Nome</label>
    <input id="r011_name" type="text" pInputText [(ngModel)]="filters.name"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_state">UF</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r011_state" [options]="comboOptions.state" [(ngModel)]="filters.state" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r011_role">Perfil</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r011_role" [options]="comboOptions.role" [(ngModel)]="filters.role" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
</div>
